import React from 'react';
import { motion } from 'framer-motion';
import Dashboard from './Dashboard';

const HeroSection = () => {
  const triggerModal = () => {
    window.dispatchEvent(new Event('openModal'));
  };

  return (
    <section className="relative pt-24 pb-20 lg:pt-32 lg:pb-32 overflow-hidden border-b border-gray-800 animate-glow-border gradient-loop-bg">
      <div className="absolute inset-0 bg-grid-pattern opacity-20 pointer-events-none"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="lg:w-1/2 text-center lg:text-left"
          >
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.6 }}
              className="inline-flex items-center gap-2 bg-gray-900/80 backdrop-blur-sm border border-gray-700 rounded-full px-4 py-1 mb-6 animate-float"
            >
              <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse-fast"></span>
              <span className="text-xs font-medium text-gray-300">
                OPT/H1B Clock is Ticking ⏳
              </span>
            </motion.div>

            <motion.h1 
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.8 }}
              className="text-4xl md:text-6xl font-extrabold leading-tight mb-6"
            >
              Don't Let Your Master's Degree
              <br/>
              <span className="text-pbi-yellow">
                Die in a Warehouse.
              </span>
            </motion.h1>

            <motion.p 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.6 }}
              className="text-gray-300/90 text-lg mb-8 leading-relaxed max-w-xl mx-auto lg:mx-0"
            >
              Calling all African Scholars in the USA: Stop settling for security guard, nursing assistant, or Uber shifts.
              <br/><br/>
              Master the #1 skill that moves you from "Survival Jobs" to
              <strong className="text-white"> High-Paying Corporate Roles</strong> with Visa Sponsorship potential.
            </motion.p>

            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8, duration: 0.6 }}
              className="grid grid-cols-3 gap-4 mb-10 border-t border-b border-gray-800/50 py-6"
            >
              <div className="text-center lg:text-left">
                <h3 className="text-xl font-bold text-white">No Coding</h3>
                <p className="text-xs text-gray-500 uppercase tracking-wider">Easy to Learn</p>
              </div>
              <div className="text-center lg:text-left border-l border-gray-800/50 pl-4">
                <h3 className="text-xl font-bold text-white">H1B Ready</h3>
                <p className="text-xs text-gray-500 uppercase tracking-wider">In-Demand Skill</p>
              </div>
              <div className="text-center lg:text-left border-l border-gray-800/50 pl-4">
                <h3 className="text-xl font-bold text-white">100% Practical</h3>
                <p className="text-xs text-gray-500 uppercase tracking-wider">Real Projects</p>
              </div>
            </motion.div>

            <motion.button 
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 1, duration: 0.6 }}
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.98 }}
              className="w-full md:w-auto btn-shine text-lg font-bold px-10 py-4 rounded-lg shadow-[0_0_20px_rgba(242,200,17,0.3)] hover:shadow-[0_0_30px_rgba(242,200,17,0.6)] transition-all duration-300 flex items-center justify-center gap-3"
              onClick={triggerModal}
            >
              <i className="fa-solid fa-download animate-bounce"></i>
              Get Your Road Map
            </motion.button>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4, duration: 0.8 }}
            className="lg:w-1/2 w-full perspective-1000"
          >
            <div className="animated-border-box">
              <div className="animated-border-content">
                <Dashboard />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;